/**
 * Image Swatches AJAX Variant Selection
 * Professional implementation using Shopify Section Rendering API
 */

document.addEventListener('DOMContentLoaded', () => {
  initImageSwatches();
});

function initImageSwatches() {
  const swatches = document.querySelectorAll('.image-swatches__item');
  if (swatches.length === 0) return;

  swatches.forEach(swatch => {
    // Prevent duplicate listeners if re-initialized
    if (swatch.dataset.initialized) return;
    swatch.dataset.initialized = "true";

    swatch.addEventListener('click', function(e) {
      e.preventDefault();
      
      const url = this.getAttribute('href');
      const sectionId = this.dataset.sectionId;
      const color = this.dataset.color;

      if (!url || !sectionId) return;

      // 1. UI Updates (Immediate feedback)
      swatches.forEach(s => s.classList.remove('is-active'));
      this.classList.add('is-active');

      const labelValue = document.querySelector('.image-swatches__current-value');
      if (labelValue) {
        labelValue.textContent = color.toUpperCase();
      }

      // 2. Add loading state to the section
      const sectionContainer = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (sectionContainer) {
        sectionContainer.classList.add('is-loading');
        // Optional: add a CSS transition for opacity or a spinner
      }

      // 3. Update URL without refresh
      window.history.replaceState({ path: url }, '', url);

      // 4. Fetch new section content
      const fetchUrl = `${url}${url.includes('?') ? '&' : '?'}section_id=${sectionId}`;
      
      fetch(fetchUrl)
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // The Section Rendering API returns the section's liquid content.
          // We look for the element with the same data-section-id.
          const newSectionContent = doc.querySelector(`[data-section-id="${sectionId}"]`);
          const currentSectionContent = document.querySelector(`[data-section-id="${sectionId}"]`);

          if (newSectionContent && currentSectionContent) {
            // Trigger unload event for theme JS to clean up (sliders, etc.)
            currentSectionContent.dispatchEvent(new CustomEvent('shopify:section:unload', {
              detail: { sectionId: sectionId },
              bubbles: true
            }));

            // Replace the entire element to ensure a clean state (removes old event listeners)
            const parent = currentSectionContent.parentNode;
            parent.replaceChild(newSectionContent, currentSectionContent);
            
            // 5. Re-initialize Theme Logic
            // CRITICAL: Dispatch 'shopify:section:load' on the PARENT container.
            // theme.js uses evt.target.querySelector('[data-section-id]') which fails 
            // if fired on the section itself.
            parent.dispatchEvent(new CustomEvent('shopify:section:load', {
              detail: { sectionId: sectionId },
              bubbles: true
            }));

            // Re-initialize our own swatch listeners for the new content
            initImageSwatches();
            
            // Scroll to top of product if needed (optional)
            // currentSectionContent.scrollIntoView({ behavior: 'smooth' });
          } else {
            // Fallback: if we can't find the section, do a full reload
            window.location.href = url;
          }
        })
        .catch(error => {
          console.error("Error fetching section:", error);
          window.location.href = url; // Hard fallback
        })
        .finally(() => {
          if (sectionContainer) {
            sectionContainer.classList.remove('is-loading');
          }
        });
    });
  });
}

